export const FIRST_NAME_FIELD_LENGTH = 30;
export const LAST_NAME_FIELD_LENGTH = 30;
export const CLIENT_COMMENT_MAX_LENGTH = 10000;
